import { Grid, Link, Typography } from "@mui/material";
import { getEnvironmentVariable } from "../../global/environmentVariables";
const REDIRECT_DOMAIN = getEnvironmentVariable("REDIRECT_DOMAIN");

export const AgeInfo = ({ siteTitle }) => {
  return (
    <Grid item xs={12}>
      <Typography variant="caption" color="text.secondary">
        In order to use the Website or Services provided by {siteTitle} you must
        be 13 years of age or older. By submitting your information, you confirm
        that you are over 18 years of age, or if you are between 13 and 18 years
        of age, you have your parent or legal guardian's permission to use our
        Website or Services. Please review our{" "}
        <Link href={`${REDIRECT_DOMAIN || ""}/privacy`} target="_blank">
          Privacy
        </Link>{" "}
        and{" "}
        <Link href={`${REDIRECT_DOMAIN || ""}/eula`} target="_blank">
          Website Terms of Use
        </Link>{" "}
        for more information.
      </Typography>
    </Grid>
  );
};
